import { useEffect, useRef, useState } from "react"

export default function LazySection({
  children,
  rootMargin = "600px 0px",
  minHeight = 240,
  className = "",
}) {
  const containerRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (isVisible) return
    const node = containerRef.current
    if (!node || typeof IntersectionObserver === "undefined") {
      setIsVisible(true)
      return
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setIsVisible(true)
          observer.disconnect()
        }
      },
      { rootMargin }
    )

    observer.observe(node)
    return () => observer.disconnect()
  }, [isVisible, rootMargin])

  return (
    <div
      ref={containerRef}
      className={className}
      style={{ minHeight }}
      aria-busy={!isVisible}
    >
      {isVisible ? (
        children
      ) : (
        <div className="lazy-section-placeholder" aria-hidden="true" />
      )}
    </div>
  )
}
